// extracted by mini-css-extract-plugin
export default {"mainWrapper":"ViewWarehouseModal_mainWrapper__bQKlX","fullGrid":"ViewWarehouseModal_fullGrid__EDDiy"};